// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { memoizeFunction } from "@fluentui/react";

/**
 * Given a function that is used as an event handler, execute the given function after the handler has been executed.
 * An example would be to execute a function that logs that an event happened after handling the event.
 *
 * NOTE: For perf. reasons this function has to be memoized. This, however breaks types for this function.
 * Will fix this with https://office.visualstudio.com/OC/_workitems/edit/3317242
 */

export const executeFunctionAfterHandler = memoizeFunction(
  <T extends (...args: any[]) => void>(
    handler: T | undefined,
    functionToExecute: () => void
  ): T => {
    // tslint:disable-next-line:no-function-expression
    return function wrappedFunction(...args: any[]): void {
      if (handler) {
        handler(...args);
      }
      functionToExecute();
    } as T;
  }
);
